import React from 'react';
import { observer } from 'mobx-react';
import moment from 'moment';

// Translations
import translate from '../Translate.js';

// Dependencies
import DOMPurify from 'dompurify';

// Components
import * as icons from '../Icons/Icons';
import SessionDetail from '../Sessions/SessionDetail';

const Incidents = observer(class Incidents extends React.Component {
  constructor() {
    super();
    this.toggleDetails = this.toggleDetails.bind(this);
    this.toggleClosed = this.toggleClosed.bind(this);
    this.getStudentName = this.getStudentName.bind(this);
    this.getSessionDate = this.getSessionDate.bind(this);
    this.closeIncident = this.closeIncident.bind(this);
  }

  componentWillMount() {
    this.state = {
      target: null,
      closedVisible: false
    }

    // If incidents aren’t provided as a prop, get them for the exam
    if(!this.props.events) {
      this.examSid = this.props.routing.location.query.eventsFor;
      this.props.store.ExamStore.getExamEvents(this.examSid);
    } else if(this.props.exam) {
      this.examSid = this.props.exam.sid;
    }
  }

  toggleDetails(e) {
    e.preventDefault();

    const details = e.target.getAttribute('data-target');

    if (this.state.target !== details) {
      this.setState({
        target: details
      });
    } else {
      this.setState({
        target: null
      });
    }
  }

  toggleClosed() {
    this.setState({
      closedVisible: !this.state.closedVisible
    });
  }

  getStudentName(event) {
    let { student } = event;

    return student ?
      `${student.firstName || ''} ${student.lastName || ''}` :
      '';
  }

  getSessionDate(event) {
    const { userTimezone } = this.props.store.SessionStore;

    if(event.session && event.session.appointmentDate) {
      let date = moment(event.session.appointmentDate);
      return `${moment.utc(date).tz(userTimezone).format('MM/DD/YYYY [at] h:mma z')}`;
    } else {
      return '';
    }
  }

  closeIncident(e, examSid, event){
    e.preventDefault();
    let callback = () => {
      this.props.store.SessionStore.showToaster(this.props.translation.close_success, 'success');
    }
    this.props.store.ExamStore.closeExamEvent(examSid, event, callback);
  }

  showSession(sessionSid, session, examSid) {
    const { SessionStore } = this.props.store;

    SessionStore.showModal = true;

    SessionStore.modalContent = <SessionDetail
                                  {...this.props}
                                  examSid={examSid}
                                  sessionSid={sessionSid}
                                  modal={true}
                                  hideIncidents={true}
                                />;
  }

  renderIncident(incident, i, closed) {
    const { translation } = this.props;
    const { SessionStore } = this.props.store;
    const { userTimezone } = SessionStore;

    function incidentClass(type) {
      if(type) {
        if(type.toLowerCase().indexOf('noisy') > -1) {
          return 'noisy';
        }

        if(type.toLowerCase().indexOf('ill') > -1) {
          return 'ill';
        }

        if(type.toLowerCase().indexOf('injured') > -1) {
          return 'injured';
        }

        if(type.toLowerCase().indexOf('time') > -1) {
          return 'time';
        }

        if(type.toLowerCase().indexOf('space') > -1) {
          return 'space';
        }

        if(type.toLowerCase().indexOf('technical') > -1) {
          return 'technical';
        }

        if(type.toLowerCase().indexOf('non-permitted') > -1) {
          return 'non-permitted-items';
        }

        if(type.toLowerCase().indexOf('help') > -1) {
          return 'outside-help';
        }
      }

      return 'other';
    }

    function incidentIcon(type) {
      if(type) {
        if(type.toLowerCase().indexOf('noisy') > -1) {
          return <icons.icon_noisy />;
        }

        if(type.toLowerCase().indexOf('ill') > -1) {
          return <icons.icon_ill />;
        }

        if(type.toLowerCase().indexOf('injured') > -1) {
          return <icons.icon_injured />;
        }

        if(type.toLowerCase().indexOf('time') > -1) {
          return <icons.icon_time />;
        }

        if(type.toLowerCase().indexOf('space') > -1) {
          return <icons.icon_space />;
        }

        if(type.toLowerCase().indexOf('technical') > -1) {
          return <icons.icon_technical />;
        }

        if(type.toLowerCase().indexOf('non-permitted') > -1) {
          return <icons.icon_non_permitted_items />;
        }

        if(type.toLowerCase().indexOf('help') > -1) {
          return <icons.icon_outside_help />;
        }
      }

      return <icons.icon_other />;
    }

    return (
      <article
        key={i}
        className={`
          incident incident--${incidentClass(incident.eventType.title)}
          ${incident.status.toLowerCase() === 'closed' ? 'incident--closed' : ''}
        `}
      >
        <strong className="incident__title subtitle">
          {incidentIcon(incident.eventType.title)}
          {incident.subject}
        </strong>

        <ul className="data">
          {incident.student &&
            <li>
              <strong>{translation.student}</strong>
              <p>{this.getStudentName(incident)}</p>
            </li>
          }
          {incident.eventType && incident.eventType.title &&
            <li>
              <strong>{translation.type}</strong>
              <p className="capitalize">{incident.eventType.name}</p>
            </li>
          }
          <li>
            <strong>{translation.session_date}</strong>
            <p>{this.getSessionDate(incident)}</p>
          </li>
          {incident.session &&
            <li>
              <strong>{translation.session_status}</strong>
              <p>{incident.session.status}</p>
            </li>
          }
          {!incident.session && this.props.session &&
            <li>
              <strong>{translation.session_status}</strong>
              <p>{this.props.session.status}</p>
            </li>
          }
        </ul>

        <ul className="incident__tools">
          <li>
            <a
              className={`btn--expand btn--expand-alt ${this.state.target === `details${i}` ? 'expanded' : ''}`}
              href={`#incident-details-${i}`}
              data-target={`details${i}`}
              onClick={this.toggleDetails}
            >
              {this.state.target === `details${i}` &&
                translation.less_information
              }

              {this.state.target !== `details${i}` &&
                translation.more_information
              }
            </a>
          </li>
          <li>
            <a href="#"
              onClick={(e) => this.closeIncident(e, this.examSid, incident)}
            >
              <icons.iconTimes /> {translation.close_incident}
            </a>
          </li>
        </ul>

        <section
          id={`incident-details-${i}`}
          className="incident__details"
          data-open={this.state.target === `details${i}`}
        >
          <h3 className="incident__heading">{translation.incident_information}</h3>

          <ul className="incident__data">
            <li>
              <strong className="subtitle">{translation.incident}</strong>

              <dl>
                <dt>{translation.number}:</dt>
                  <dd>{incident.sid}</dd>
                <dt>{translation.time}:</dt>
                  <dd>{moment.utc(incident.eventTime).tz(userTimezone).format('MM/DD/YYYY [at] h:mma z')}</dd>
                <dt>{translation.status}:</dt>
                  <dd>{incident.status}</dd>
                <dt>{translation.direct_witness}:</dt>
                  <dd>{incident.directWitness}</dd>
                <dt className="body">{translation.details}:</dt>
                  <dd
                    className="body"
                    dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(incident.details)}}
                  ></dd>

                {incident.potentialDamage &&
                  <dt className="body">{translation.potential_damage}:</dt>
                }
                {incident.potentialDamage &&
                  <dd className="body">{incident.potentialDamage}</dd>
                }

                {incident.correctiveActionDetails &&
                  <dt className="body">{translation.corrective_action}:</dt>
                }
                {incident.correctiveActionDetails &&
                  <dd className="body">{incident.correctiveActionDetails}</dd>
                }
              </dl>
            </li>
            <li>
              {incident.session && incident.session.proctor &&
                <div>
                  <strong className="subtitle">{translation.proctor_info}</strong>
                  <dl>
                    <dt>{translation.name}:</dt>
                      <dd>{incident.session.proctor.firstName || ''} {incident.session.proctor.lastName || ''}</dd>
                    <dt>{translation.phone}:</dt>
                      <dd>{incident.session.proctor.phone}</dd>
                    <dt>{translation.email}:</dt>
                      <dd><a href={`mailto:${incident.session.proctor.email}`}>{incident.session.proctor.email}</a></dd>
                  </dl>
                </div>
              }

              <strong className="subtitle">{translation.contact_info}</strong>

              <dl>
                <dt>{translation.contact_person}:</dt>
                  <dd>{incident.contactPerson}</dd>
                <dt>{translation.contact_phone}:</dt>
                  <dd>{incident.contactPhone}</dd>
                <dt>{translation.contact_email}:</dt>
                  <dd>{incident.contactEmail}</dd>
              </dl>
            </li>
          </ul>

          <button
            className="btn"
            onClick={() => this.showSession(incident.examSessionSid, incident.session)}
          >
            {translation.show_session}
          </button>
        </section>
      </article>
    );
  }

  render() {
    const { translation } = this.props;
    let events = [];

    if(this.props.events) {
      events = this.props.events;
    } else {
      events = this.props.store.ExamStore.examEvents;
    }

    let openEvents = events.filter(event => {
      return event.status === 'Open';
    });

    let closedEvents = events.filter(event => {
      return event.status === 'Closed';
    });

    return (
      <div className="panel__section">
        <section className="panel__section">
          <h3 className="panel__heading">{translation.open_heading}</h3>

          {openEvents.map(
            (key, i) => this.renderIncident(key, i, false)
          )}
        </section>

        <section className={`panel__section ${this.state.closedVisible ? '' : 'hidden'}`}>
          <h3 className="panel__heading closed-heading" onClick={this.toggleClosed}>{translation.closed_heading}</h3>

          {closedEvents.map(
            (key, i) => this.renderIncident(key, i, true)
          )}
        </section>
      </div>
    )
  }
})

export default translate('Incidents')(Incidents);



// WEBPACK FOOTER //
// ./src/app/components/Modules/Incidents.js